document.addEventListener('DOMContentLoaded', function () {
  const maxQuantity = 10;
  const quantityWrappers = document.querySelectorAll('.js-qty__wrapper');

  quantityWrappers.forEach(wrapper => {
    const quantityInput = wrapper.querySelector('.js-qty__num');
    const plusButton = wrapper.querySelector('.js-qty__adjust--plus');
    const minusButton = wrapper.querySelector('.js-qty__adjust--minus');

    // Handle direct input changes
    quantityInput.addEventListener('input', function () {
      let value = parseInt(this.value);
      if (isNaN(value)) value = 1; // Default to 1 if invalid
      if (value > maxQuantity) {
        this.value = maxQuantity;
        alert('For orders over 10, please contact us.');
      }
    });

    // Handle plus button click
    plusButton.addEventListener('click', function () {
      let value = parseInt(quantityInput.value);
      if (value >= maxQuantity) {
        quantityInput.value = maxQuantity;
        alert('For orders over 10, please contact us.');
      }
    });

    // Handle minus button click (optional, for completeness)
    minusButton.addEventListener('click', function () {
      let value = parseInt(quantityInput.value);
      if (value <= 1) {
        quantityInput.value = 1; // Ensure minimum is 1
      }
    });
  });
});